import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Scroller from './components/Scroller/Scroller';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import IndustryProducts from './components/IndustryProducts/IndustryProducts';
import Notices from './components/Notices/Notices'
import Footer from './components/Footer/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './App.css';

const App = () => {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Router>
      <div className='app'>
        <Scroller />
        <Header />
        <Routes>
          <Route path='/' element={<Main/>} />
          <Route path='/industry-products/:industry' element={<IndustryProducts />}/>
          <Route path="/notices/privacycenter" element={<Notices section="privacycenter" />} />
          <Route path="/notices/termsandconditions" element={<Notices section="termsandconditions" />} />
          <Route path="/notices/privacypolicy" element={<Notices section="privacypolicy" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
